const LENGTH_UNIT_REGEX =
  /\d+(%|px|px_em|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/
const semanticTokenRegex = /^([a-z\d]+[-_]?)+$/

export const checkIsLengthWithUnit = (value: string) => {
  return LENGTH_UNIT_REGEX.test(value)
}

export const checkIsPxOrPxEm = (value: string) => {
  return /^\d+(px|px_em)$/.test(value)
}

export const checkIsSemanticToken = (value: string) => {
  return semanticTokenRegex.test(value)
}
